import { ErrorHandler, Injectable } from '@angular/core';
import { AwsRumService } from './aws-rum.service';

@Injectable({ providedIn: 'root' })
export class RumErrorHandler implements ErrorHandler {
  constructor(private awsService: AwsRumService) {}
  handleError(error: any) {
    console.error(error);
    this.awsService.recordError(error);
  }
}
